import { getCurrency } from './currency';

function pickBlock(plan) {
    const prices = plan?.prices;
    if (!prices || typeof prices !== 'object') return { block: null, source: 'legacy' };

    const currency = (getCurrency() || 'USD').toLowerCase();
    if (prices[currency]) return { block: prices[currency], source: `prices.${currency}` };
    if (prices.usd) return { block: prices.usd, source: 'prices.usd (fallback)' };
    return { block: null, source: 'legacy' };
}

function fmt(value) {
    if (value === undefined || value === null || value === '') return '(empty)';
    return value;
}

function logResolution(planId, source, resolved) {
    const stripeLine  = `  stripe:    priceID=${fmt(resolved.priceID)}, discountID=${fmt(resolved.discountID)}`;
    const paddleLine  = `  paddle:    priceId=${fmt(resolved.paddle?.priceId)}, discountId=${fmt(resolved.paddle?.discountId)}`;
    const solidLine   = `  solidgate: productPriceId=${fmt(resolved.solidgate?.productPriceId)}, couponId=${fmt(resolved.solidgate?.couponId)}`;
    console.log(
        `[planPrices] plan="${planId ?? '?'}" source=${source}\n${stripeLine}\n${paddleLine}\n${solidLine}`
    );
}

export function resolvePlanPrices(plan) {
    if (!plan) {
        const empty = { priceID: undefined, discountID: undefined, paddle: undefined, solidgate: undefined };
        logResolution(undefined, 'no-plan', empty);
        return empty;
    }

    const { block, source } = pickBlock(plan);

    const resolved = block
        ? {
            priceID: block.stripe?.priceID,
            discountID: block.stripe?.discountID,
            paddle: block.paddle,
            solidgate: block.solidgate,
        }
        : {
            priceID: plan.priceID,
            discountID: plan.discountID,
            paddle: plan.paddle,
            solidgate: plan.solidgate,
        };

    logResolution(plan.id, source, resolved);
    return resolved;
}
